import React from 'react';
import './FaqPage.css';

import { PageTitle } from '../../../components';
import { FAQs } from '../../../sections';



const FaqPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'faqs'} page={'faqs'} />

      <FAQs />

    </>
  );
};

export default FaqPage;